import { useNavigate } from "react-router-dom";
import { ArrowRight, Calculator, Layers, Wand2 } from "lucide-react";
import {
  buildDerivedVariablesPath,
  buildFormulaBuilderPath,
  componentEditPath,
} from "./componentFormulaNav";

/**
 * Quick links between Payroll Components, Formula Builder, and Derived Variables.
 * @param {"list"|"edit"|"formula"|"derived"} activePage
 */
export default function PayrollComponentToolsBar({
  activePage = "list",
  componentId = null,
  componentCode = "",
}) {
  const navigate = useNavigate();
  const returnTo = componentId ? componentEditPath(componentId) : "/salary-v2/components";
  const ctx = { componentId, componentCode, returnTo };

  return (
    <div className="scp-tools-bar" role="navigation" aria-label="Payroll component tools">
      <p className="scp-tools-bar-label">Related payroll tools</p>
      <div className="scp-tools-bar-actions">
        <button
          type="button"
          className={`scp-tools-btn${activePage === "list" || activePage === "edit" ? " is-active" : ""}`}
          onClick={() => navigate(componentId ? returnTo : "/salary-v2/components")}
        >
          <Layers size={16} />
          Payroll Components
        </button>
        <button
          type="button"
          className={`scp-tools-btn${activePage === "formula" ? " is-active" : ""}`}
          onClick={() => navigate(buildFormulaBuilderPath(ctx))}
        >
          <Calculator size={16} />
          Formula Builder
        </button>
        <button
          type="button"
          className={`scp-tools-btn${activePage === "derived" ? " is-active" : ""}`}
          onClick={() => navigate(buildDerivedVariablesPath(ctx))}
        >
          <Wand2 size={16} />
          Derived Variables
        </button>
        {activePage === "edit" && componentId ? (
          <button
            type="button"
            className="scp-tools-btn scp-tools-btn-accent"
            onClick={() => navigate(buildFormulaBuilderPath(ctx))}
          >
            Edit formula for {componentCode || "component"} <ArrowRight size={14} />
          </button>
        ) : null}
      </div>
    </div>
  );
}
